import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '~/components/ui/accordion';
import { InfoInterface } from '~/payload-types';
import { Info } from 'lucide-react';

import LexicalRenderer from '../LexicalRenderer';

type Props = InfoInterface & {};

const InfoBlock = (props: Props) => {
  const { title, content } = props;

  return (
    <Accordion
      type="single"
      collapsible
      className="-mt-2 mb-2 border-t border-dashed"
    >
      <AccordionItem value="info" className="border-dashed">
        <AccordionTrigger className="flex items-center gap-2">
          <Info className="text-primary h-5 w-5" />
          <p className="text-lg font-medium">{title}</p>
          <p className="grow"></p>
        </AccordionTrigger>
        <AccordionContent>
          <LexicalRenderer data={content} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default InfoBlock;
